export default function initGuaranteeQuiz() {
  const quizzes = document.querySelectorAll('.js-guarantee-quiz');

  if (!quizzes.length) return;

  quizzes.forEach((quiz) => {
    const steps = [...quiz.querySelectorAll('.guarantee-quiz__step')];
    const progressBar = quiz.querySelector('.js-guarantee-quiz-progress');

    if (!steps.length || !progressBar) return;

    const totalQuestionSteps = 4;
    const answerKeys = ['state', 'sleep_problem', 'related_issue', 'duration'];

    let currentStep = 0;

    const answers = {
      state: null,
      sleep_problem: null,
      related_issue: null,
      duration: null,
    };

    const progressMap = [20, 40, 60, 80, 100];

    function setProgress(stepIndex) {
      progressBar.style.width = `${progressMap[stepIndex] || 20}%`;
    }

    function showStep(stepIndex) {
      steps.forEach((step, index) => {
        step.classList.toggle('is-active', index === stepIndex);
      });

      quiz.setAttribute('data-step', stepIndex);
      currentStep = stepIndex;

      setProgress(stepIndex);
    }

    function saveAnswer(stepIndex, value) {
      const key = answerKeys[stepIndex];

      if (!key) return;

      answers[key] = value;
    }

    function goNext() {
      if (currentStep < totalQuestionSteps) {
        showStep(currentStep + 1);
      }
    }

    quiz.addEventListener('click', (event) => {
      const answerBtn = event.target.closest('.js-guarantee-quiz-answer');

      if (answerBtn) {
        const stepEl = answerBtn.closest('.guarantee-quiz__step');
        const stepIndex = Number(stepEl.dataset.step);

        stepEl.querySelectorAll('.js-guarantee-quiz-answer').forEach((btn) => {
          btn.classList.remove('is-selected');
        });

        answerBtn.classList.add('is-selected');
        saveAnswer(stepIndex, answerBtn.dataset.value);

        setTimeout(() => {
          goNext();
        }, 250);

        return;
      }
    });

    showStep(0);

    // debug if needed
    quiz.guaranteeQuizAnswers = answers;
  });

  function smoothScrollTo(targetY, duration = 800) {
    const startY = window.pageYOffset;
    const distance = targetY - startY;
    const startTime = performance.now();

    function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutCubic(progress);

      window.scrollTo(0, startY + distance * easedProgress);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }

  // smooth scroll fallback for anchor links
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();

    const offset = 80; // header height if needed
    const targetY = target.getBoundingClientRect().top + window.pageYOffset - offset;

    smoothScrollTo(targetY, 850);
  });
}
